import * as mainApi from 'util/server/mainApi'

export function fetchTaxSummary(year = String(new Date().getFullYear() - 1)) {
  return (dispatch) => {
    return mainApi.getTaxSummary(year).then((resp) => {
      return dispatch({ type: 'SET_TAX_SUMMARY', year, summary: resp.data.summary, downloads: resp.data.downloads })
    })
  }
}
